import { Box, Menu } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUserInfoData } from '../../../reducers/userInfoReducer';
import { MenuItemsUser } from '../user-menu/MenuItemsUser';
import { UserDialogTabTypes, UserDialogWrapper } from '../user-dialog/UserDialogWrapper';
import { UserSummaryForHeader } from './UserSummaryForHeader';
import usePopover from '../../../hooks/usePopover';
import { useUserDialogContext } from '../user-dialog/UserDialogContext';
import { NotificationsPopover } from '../notification-center/NotificationsPopover';
import useNotifications from './useNotifications';
import { RoleManagerProvider } from '../role-manager/RoleManagerContext';
import { useAccountSelectionContext } from '../../account-selection/AccountSelectionContext';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';

const UserMenu = () => {
  const { multiAccounts } = useFeatureToggle();
  const userInfo = useSelector(selectUserInfoData);
  const { isOpen: isUserDialogOpen, openDialog: openUserDialog } = useUserDialogContext();
  const { isPopoverOpen, closePopover, openPopover, anchorElement, anchorRef } = usePopover();
  const { openAccountSelection } = useAccountSelectionContext();
  const dialogPaperProps = {
    sx: {
      width: '600px',
      height: '740px',
      '.MuiDialogContent-root': {
        padding: '0 24px 8px',
      },
      '.confirm-dialog-header': {
        padding: 3,
      },
    },
  };
  const { notifications, totalUnread } = useNotifications();
  const hasUnreadNotifications = totalUnread > 0;
  const {
    isPopoverOpen: isNotificationsPopoverOpen,
    closePopover: closeNotificationsPopover,
    openPopover: openNotificationsPopover,
  } = usePopover();

  return (
    <Box>
      <Box
        ref={anchorRef}
        id="basic-button"
        aria-controls={isPopoverOpen ? 'user-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isPopoverOpen ? 'true' : undefined}
        onClick={openPopover}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <UserSummaryForHeader
          user={userInfo}
          isActive={isPopoverOpen}
          hasUnreadNotifications={hasUnreadNotifications}
        />
      </Box>

      <Menu
        id="user-menu"
        anchorEl={anchorElement}
        open={isPopoverOpen}
        onClose={() => closePopover()}
        MenuListProps={{
          'aria-labelledby': 'user-menu-button',
        }}
        slotProps={{
          paper: {
            sx: (theme) => ({
              marginTop: 0,
              width: multiAccounts ? '320px' : '280px',
              boxShadow: theme.shadows[7],
            }),
          },
        }}
        anchorOrigin={{ vertical: multiAccounts ? 52 : 32, horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItemsUser
          openMyProfileDialog={() => openUserDialog(UserDialogTabTypes.PROFILE)}
          openOrgDialog={() => openUserDialog(UserDialogTabTypes.ORG)}
          openIntegrationsDialog={() => openUserDialog(UserDialogTabTypes.INTEGRATIONS)}
          closeMenu={closePopover}
          openNotificationsPopover={openNotificationsPopover}
          isNotificationsPopoverOpen={isNotificationsPopoverOpen}
          hasUnreadNotifications={hasUnreadNotifications}
          openAccountSelectionDialog={openAccountSelection}
        />
      </Menu>

      {isUserDialogOpen && (
        <RoleManagerProvider>
          <UserDialogWrapper PaperProps={dialogPaperProps} />
        </RoleManagerProvider>
      )}

      <NotificationsPopover
        notifications={notifications}
        onClose={closeNotificationsPopover}
        anchorEl={anchorElement}
        isOpen={isNotificationsPopoverOpen}
        closeUserMenu={closePopover}
      />
    </Box>
  );
};

export default UserMenu;
